import React from 'react'

export const Manage = () => {
    return (
        <div>Manage</div>
    )
}
